<form-layout
    [showSave]="canSave"
    [showVorabCheck]="true"
    (onVorabCheck)="onVorabCheckClick()"
    (onSave)="onSaveClick()"
    (onBack)="onBackClick()"
    (onNext)="onSaveAndNextClick()">
    
    <project-data [form]="projectDataProcessStepForm" [aiResponseLoading]="aiResponseLoading" [aiResponse]="aiResponse" [aiResponseFinished]="aiResponseFinished"></project-data>
</form-layout>
